import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { SSOLoginForm } from "@/components/auth/sso-login-form"
import { FRONTEND_ROUTES } from "@/constants"
import { useAuth } from "@/contexts/auth"
export function SsoLoginPage() {
  const navigate = useNavigate()
  const { authData } = useAuth()

  useEffect(() => {
    if (authData?.accessToken) {
      navigate(FRONTEND_ROUTES.DASHBOARD.href, {
        replace: true,
      })
    }
  }, [authData, navigate])

  return <SSOLoginForm />
}
